import { render, staticRenderFns } from "./PDF_Price.vue?vue&type=template&id=f7854266&scoped=true"
import script from "./PDF_Price.vue?vue&type=script&lang=js"
export * from "./PDF_Price.vue?vue&type=script&lang=js"
import style0 from "./PDF_Price.vue?vue&type=style&index=0&id=f7854266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7854266",
  null
  
)

export default component.exports